import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/stock/`;

const addStockData = async (formData) => {
    console.log(formData)
    return await axios.post(API_URL, formData);
};

const confirmMonthlyStock = async (yearMonth) => {
    return await axios.post(API_URL + 'confirm/', { yearMonth });
};

const getStockBalance = async () => {
    return await axios.post(API_URL + 'balance/');
};

export default {
    addStockData,
    confirmMonthlyStock,
    getStockBalance
};
